import Cookies from 'js-cookie';

export const ENCODED_ZUID_COOKIE = 'zjs_user_id';
export const getEncodedZUIDFromCookie = () => {
    const zillowEncodedAndURIEncodedZUID = Cookies.get(ENCODED_ZUID_COOKIE);
    if (!zillowEncodedAndURIEncodedZUID) {
        return null;
    }
    const zillowEncodedZUID = decodeURIComponent(zillowEncodedAndURIEncodedZUID);
    return zillowEncodedZUID.replace(/"/gi, '');
};
